import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { HeaderService } from '../proxy/general/controllers/header.service';

FieldBuilder.setNamespace('General');

export const MACHINEHEADERCHANGEHISTORIC_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('headerId', 'Entity.Header', HeaderService)
    .required()
    .displayFromNested('header.name')
    .build(),
  FieldBuilder
    .date('dateFrom', 'Entity.MachineHeaderChangeHistoric.DateFrom')
    .lessThanField('dateTo', 'General::Entity.MachineHeaderChangeHistoric.DateTo')
    .required()
    .build(),
  FieldBuilder
    .date('dateTo', 'Entity.MachineHeaderChangeHistoric.DateTo')
    .greaterThanField('dateFrom', 'General::Entity.MachineHeaderChangeHistoric.DateFrom')
    .build(),
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .sortBy('machine.name')
    .hideInChildForms()
    .build(),
];

export const MACHINEHEADERCHANGEHISTORIC_CONFIG = {
  entityName: 'MachineHeaderChangeHistoric',
  localizationKey: 'General::Entity.MachineHeaderChangeHistoric',
  fields: MACHINEHEADERCHANGEHISTORIC_FIELDS,
  permission: 'GeneralMachinesAndVehicles.MachineHeaderChangeHistorics',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
